// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2CP_R","overflowing":"ReadFullNote_overflowing__3Njzr"};